var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info-circle"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FFD21E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.5625 23C19.894 23 20.212 22.8683 20.4464 22.6339C20.6808 22.3995 20.8125 22.0815 20.8125 21.75V14.25C20.8125 13.9185 20.6808 13.6005 20.4464 13.3661C20.212 13.1317 19.894 13 19.5625 13C19.231 13 18.913 13.1317 18.6786 13.3661C18.4442 13.6005 18.3125 13.9185 18.3125 14.25V21.75C18.3125 22.0815 18.4442 22.3995 18.6786 22.6339C18.913 22.8683 19.231 23 19.5625 23ZM19.5625 28C19.8715 28 20.1736 27.9084 20.4306 27.7367C20.6875 27.565 20.8878 27.321 21.0061 27.0354C21.1243 26.7499 21.1553 26.4358 21.095 26.1327C21.0347 25.8296 20.8859 25.5512 20.6674 25.3326C20.4488 25.1141 20.1704 24.9653 19.8673 24.905C19.5642 24.8447 19.2501 24.8757 18.9646 24.9939C18.679 25.1122 18.435 25.3125 18.2633 25.5694C18.0916 25.8264 18 26.1285 18 26.4375C18 26.8519 18.1646 27.2493 18.4576 27.5424C18.7507 27.8354 19.1481 28 19.5625 28Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.ec47fb61c26560cf5d71a18a559f4e45.svg";
export { ForwardRef as ReactComponent };